import { render, staticRenderFns } from "./CustomFieldText.vue?vue&type=template&id=efd3594c"
import script from "./CustomFieldText.vue?vue&type=script&lang=ts"
export * from "./CustomFieldText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports